import React, { useState, Suspense } from 'react';
import SideBar from './Components/SideBar';
import TopBar from './Components/TopBar';
import {PagesTabsObj} from './Common/PagesObj'
 
const App = () => {
    const [activeMenu, setActiveMenu] = useState('timezone');
    const handleMenuItemClick = (menu) => {
        setActiveMenu(menu);
    };

   
    return (
        <main className="flex">
            <SideBar onMenuItemClick={handleMenuItemClick} activeMenu={activeMenu} />
            <div className="flex flex-col flex-grow">
                <TopBar activeMenu={activeMenu} />
                <div className="text-white bg-black">
                    <Suspense fallback={<div>Loading...</div>}>
                    {PagesTabsObj.map((items) => {
                        return (
                        <div key={items.key} className={activeMenu === items.name ? 'block' : 'hidden'}>
                            {items.component}
                        </div>
                        )
                    })}
                    </Suspense>
                </div>
            </div>
        </main>
    );
};

export default App;
